'use client';
import TxProcessingModal from '@/src/components/AppComponents/TxProcessingModal/TxProcessingModal';
import TxUserConfirmationModal from '@/src/components/AppComponents/TxUserConfirmationModal/TxUserConfirmationModal';
import { Button } from '@/src/components/Commons/Button';
import ToggleProController from '@/src/components/Commons/Controllers/ToggleProController/ToggleProController';
import TogleViewListOrDetailsController from '@/src/components/Commons/Controllers/TogleViewListOrDetailsController/TogleViewListOrDetailsController';
import LoaderButton from '@/src/components/Commons/LoaderButton/LoaderButton';
import { useFundDepositWithdrawCalculations } from '@/src/hooks/useFundDepositWithdrawCalculations';
import { IFundDetailsForUsers } from '@/src/hooks/useFundDetailsForHome';
import { IFundListForUsers } from '@/src/hooks/useFundListForHome';
import useWindowSize from '@/src/hooks/useResponsive';
import { useServerTime } from '@/src/hooks/useServerTime';
import { useTransactions } from '@/src/hooks/useTransactions';
import {
    ADA_THRESHOLD,
    createToken_With_Amount,
    delayCall,
    delayCallAsync,
    explainErrorTx,
    FundBtnHandlers,
    FundDepositTxParams,
    FundEntity,
    FundTxApiCalls,
    FundWithdrawTxParams,
    LucidToolsFrontEnd,
    pushSucessNotification,
    pushWarningNotification,
    TOKEN_ADA_TICKER,
    Token_With_Metadata_And_Amount,
    TX_PROPAGATION_DELAY_MS,
} from '@/src/lib/MayzSmartDB';
import { hexToStr, toJson } from '@/src/lib/MayzSmartDB';
import { INVESTUNIT_MULTIPLIER, TASK } from '@/src/utils/constants';
import { ROUTES } from '@/src/utils/routes';
import { useRouter } from '@/src/store/router/RouterProvider';
import { useEffect, useState } from 'react';
import styles from './Deposit.module.scss';
import Commission from './Form/ControlsPro/Commission';
import DepositForm from './Form/DepositForm';
import { Assets, TxBuilder } from '@lucid-evolution/lucid';

type DepositProps = {
    isAddingTokens: boolean;
};

export default function Deposit(props: DepositProps & IFundDetailsForUsers & IFundListForUsers) {
    //--------------------------------------
    const { isTokensStoreReady, protocol, id, fund, isAddingTokens } = props;
    //--------------------------------------
    const { width } = useWindowSize();
    const isTablet = width <= 768;
    const isMobile = width <= 480;
    //--------------------------------------
    //--------------------------------------
    const router = useRouter();
    //--------------------------------------
    const { serverTime, isServerTimeLoaded } = useServerTime();
    //--------------------------------------
    const [isDeposit, setIsDeposit] = useState<boolean>(true);
    //--------------------------------------
    // useEffect(() => {
    //     if (router.isReady) {
    //         const { isDeposit } = router.query;
    //         if (!isNullOrBlank(isDeposit as string)) {
    //             if (isDeposit === 'false') {
    //                 setIsDeposit(false);
    //             }
    //         }
    //     }
    // }, [router.isReady]);
    //--------------------------------------
    const [isValidInputTokens, setIsValidInputTokens] = useState<boolean>(true);
    const [isValidInputFT, setIsValidInputFT] = useState<boolean>(true);
    //--------------------------------------
    const [isValidInputsForTx, setIsValidInputsForTx] = useState<boolean>(false);
    //--------------------------------------
    const [inputTokens, setInputTokens] = useState<Token_With_Metadata_And_Amount[]>([]);
    const [inputFT, setInputFT] = useState(0n);
    //--------------------------------------
    const [commission_FT, setCommission_FT] = useState(0n);
    const [real_FT, setReal_FT] = useState(0n);
    //--------------------------------------
    const { available_FT_in_Wallet_Based_On_Tokens, amount_Tokens_Available_In_Wallet, amount_Tokens_Available_In_Wallet_Based_On_FT, isMaxAmountLoaded } =
        useFundDepositWithdrawCalculations({ fund, serverTime, isServerTimeLoaded });
    //--------------------------------------

    async function resetForm() {
        setInputFT(0n);
        setInputTokensBasedOnFT(0n);
        setReal_FT(0n);
        setCommission_FT(0n);
    }
    //--------------------------------------
    const onTx = async () => {
        resetForm();
        await props.refreshDetails(fund!._DB_id);
        await props.refreshList();
    };
    const onTryAgainTx = async () => {
        setIsFaildedTx(false);
        setShowProcessingTx(false);
    };
    const onFinishTx = async () => {
        // si la tx paso, ya se reseto el form en onTx, pero por las dudas, si aprienta cuando falla
        if (isFaildedTx === true) {
            resetForm();
        }
        setIsConfirmedTx(false);
        setIsFaildedTx(false);
        setShowProcessingTx(false);
    };
    //--------------------------------------
    async function checkIsValidTx() {
        let isValid =
            props.isLoadedDetails === true && isValidInputsForTx === true && isMaxAmountLoaded === true && isMaxAmountLoadedFromTxHook === true && isTokensStoreReady === true;
        if (isDeposit === true) {
            isValid = isValid;
        } else {
            isValid = isValid;
        }
        return isValid;
    }
    //--------------------------------------
    const dependenciesValidTx: any[] = [isValidInputsForTx, isDeposit, props.isLoadedDetails, isMaxAmountLoaded, isTokensStoreReady];
    //--------------------------------------
    const {
        appStore,
        walletStore,
        tokensStore,
        session,
        status,
        showUserConfirmation,
        setShowUserConfirmation,
        showProcessingTx,
        setShowProcessingTx,
        isProcessingTx,
        setIsProcessingTx,
        isFaildedTx,
        setIsFaildedTx,
        isConfirmedTx,
        setIsConfirmedTx,
        processingTxMessage,
        setProcessingTxMessage,
        processingTxHash,
        setProcessingTxHash,
        isValidTx,
        setIsValidTx,
        tokensGiveWithMetadata,
        setTokensGiveWithMetadata,
        tokensGetWithMetadata,
        setTokensGetWithMetadata,
        available_TokenGov_in_Wallet,
        available_FT_in_Wallet,
        available_ADA_in_Wallet,
        available_forSpend_ADA_in_Wallet,
        isMaxAmountLoaded: isMaxAmountLoadedFromTxHook,
        handleBtnShowUserConfirmation,
        handleBtnDoTransaction_WithErrorControl,
    } = useTransactions({ ...props, dependenciesValidTx, checkIsValidTx, onTx });
    //--------------------------------------
    //--------------------------------------
    const [showUTxOError, setShowUTxOError] = useState<boolean>(false);
    const [isProcessingArrangeUTxOTx, setIsProcessingArrangeUTxOTx] = useState<boolean>(false);
    //--------------------------------------
    useEffect(() => {
        setShowUTxOError(!checkUTxOForFund());
    }, [fund?.investUnit, fund?.fdFundFT_TN_Hex, fund?.getNET_id_CS, walletStore.uTxOsAtWallet, walletStore.isWalletDataLoaded, isDeposit]);
    //--------------------------------------
    useEffect(() => {
        if (fund !== undefined) {
            resetForm();
        }
    }, [fund]);
    //--------------------------------------
    useEffect(() => {
        if (fund !== undefined && fund.investUnit !== undefined && isTokensStoreReady === true) {
            setInputTokensBasedOnFT(0n);
        }
    }, [fund?.investUnit, isTokensStoreReady]);
    //--------------------------------------
    useEffect(() => {
        if (isMaxAmountLoaded === true && isTokensStoreReady === true) {
            if (isDeposit === true) {
                //------------
                const isValidInputTokens = inputTokens.every((inputToken) => {
                    const inWallet = amount_Tokens_Available_In_Wallet.find(([cs, tn, am]) => cs === inputToken.CS && tn === inputToken.TN_Hex && am >= inputToken.amount);
                    return inWallet !== undefined;
                });
                const isValidInputTokensWithoutZero = inputTokens.every((inputToken) => {
                    if (inputToken.amount === 0n) return false;
                    const inWallet = amount_Tokens_Available_In_Wallet.find(([cs, tn, am]) => cs === inputToken.CS && tn === inputToken.TN_Hex && am >= inputToken.amount);
                    return inWallet !== undefined;
                });
                setIsValidInputTokens(isValidInputTokens);
                //------------
                const isValidInputFTWithoutZero = inputFT > 0n;
                //------------
                setIsValidInputsForTx(isValidInputTokensWithoutZero && isValidInputFTWithoutZero);
            } else {
                //------------
                const isValidInputTokens = inputTokens.every((inputToken) => {
                    const inWallet = amount_Tokens_Available_In_Wallet_Based_On_FT.find(
                        ([cs, tn, _am]) => cs === inputToken.CS && tn === inputToken.TN_Hex && _am >= inputToken.amount
                    );
                    return inWallet !== undefined;
                });
                const isValidInputTokensWithoutZero = inputTokens.every((inputToken) => {
                    if (inputToken.amount === 0n) return false;
                    const inWallet = amount_Tokens_Available_In_Wallet_Based_On_FT.find(
                        ([cs, tn, _am]) => cs === inputToken.CS && tn === inputToken.TN_Hex && _am >= inputToken.amount
                    );
                    return inWallet !== undefined;
                });
                setIsValidInputTokens(isValidInputTokens);
                //------------
                const isValidInputFTWithoutZero = inputFT > 0n;
                //------------
                setIsValidInputsForTx(isValidInputTokensWithoutZero && isValidInputFTWithoutZero);
            }
        }
    }, [inputTokens, inputFT, isDeposit, isMaxAmountLoaded, isTokensStoreReady]);
    //--------------------------------------
    useEffect(() => {
        if (showUserConfirmation === true && fund !== undefined) {
            if (isDeposit === true) {
                const tokensToGet = [createToken_With_Amount(fund.getNET_id_CS(), fund.fdFundFT_TN_Hex, fund.tokenFT?.ticker, inputFT)];
                setTokensGetWithMetadata(tokensToGet.filter((token) => token && token.amount > 0));
                const tokensToGive = inputTokens;
                setTokensGiveWithMetadata(tokensToGive.filter((token) => token && token.amount > 0));
            } else {
                const tokensToGet = inputTokens;
                setTokensGetWithMetadata(tokensToGet.filter((token) => token && token.amount > 0));
                const tokensToGive = [createToken_With_Amount(fund.getNET_id_CS(), fund.fdFundFT_TN_Hex, fund.tokenFT?.ticker, inputFT)];
                setTokensGiveWithMetadata(tokensToGive.filter((token) => token && token.amount > 0));
            }
        }
    }, [showUserConfirmation, fund, inputTokens, inputFT, isDeposit]);
    //--------------------------------------
    const checkUTxOForFund = () => {
        if (walletStore.isWalletDataLoaded === false) return true;

        if (!fund?.investUnit || !walletStore.uTxOsAtWallet) return true;

        const uTxOs = walletStore.uTxOsAtWallet;

        // 1. Verificamos al menos 2 UTxOs ADA-only
        const adaOnlyUTxOs = uTxOs.filter((utxo) => {
            const { lovelace, ...assets } = utxo.assets;
            const hasOnlyAda = Object.keys(assets).length === 0;
            const hasManyADA = lovelace >= ADA_THRESHOLD;
            return hasOnlyAda && hasManyADA;
        });

        if (adaOnlyUTxOs.length < 2) return false;

        //---------------------------------------------
        if (isDeposit === true) {
            // ----------------- DEPOSIT PATH -----------------

            const tokenKeysFromFund = fund.investUnit.iudInvestUnit.iuValues.map(([policyId, tokenNameHex]) => `${policyId}${tokenNameHex}`);

            // Sumar total tokens del fondo en el wallet
            const totalTokensInWallet: Record<string, bigint> = {};
            for (const utxo of uTxOs) {
                const { assets } = utxo;
                for (const tokenKey of tokenKeysFromFund) {
                    if (tokenKey in assets) {
                        totalTokensInWallet[tokenKey] = (totalTokensInWallet[tokenKey] ?? 0n) + assets[tokenKey];
                    }
                }
            }

            // Buscar UNA UTxO que contenga exactamente esos tokens (ni más ni menos) + ADA
            const hasValidUTxO = uTxOs.some((utxo) => {
                const assets = utxo.assets;
                const utxoAda = assets.lovelace ?? 0n;
                const hasManyADA = utxoAda >= ADA_THRESHOLD;
                if (!hasManyADA) return false;

                const tokenKeysInUTxO = Object.keys(assets).filter((key) => key !== 'lovelace');
                const hasExactTokenKeys = tokenKeysInUTxO.length === tokenKeysFromFund.length && tokenKeysFromFund.every((key) => tokenKeysInUTxO.includes(key));

                if (!hasExactTokenKeys) return false;

                return tokenKeysFromFund.every((tokenKey) => {
                    const inThisUTxO = assets[tokenKey] ?? 0n;
                    const required = totalTokensInWallet[tokenKey] ?? 0n;
                    return inThisUTxO === required;
                });
            });

            return hasValidUTxO;
        } else {
            // ----------------- WITHDRAW PATH -----------------

            const tokenKey = `${fund.getNET_id_CS()}${fund.fdFundFT_TN_Hex}`;

            // 1. Sumar el total del token de retiro en todas las UTxOs
            let totalTokenAmount = 0n;
            for (const utxo of uTxOs) {
                totalTokenAmount += utxo.assets[tokenKey] ?? 0n;
            }

            // 2. Buscar UNA UTxO que contenga ese token (con total exacto), sin otros tokens, + ADA
            const hasValidSingleTokenUTxO = uTxOs.some((utxo) => {
                const assets = utxo.assets;
                const utxoAda = assets.lovelace ?? 0n;
                const hasManyADA = utxoAda >= ADA_THRESHOLD;
                if (!hasManyADA) return false;

                const tokenKeysInUTxO = Object.keys(assets).filter((key) => key !== 'lovelace');
                const hasOnlyThisToken = tokenKeysInUTxO.length === 1 && tokenKeysInUTxO[0] === tokenKey;
                if (!hasOnlyThisToken) return false;

                const inThisUTxO = assets[tokenKey] ?? 0n;
                return inThisUTxO === totalTokenAmount;
            });

            return hasValidSingleTokenUTxO;
        }
    };
    //--------------------------------------
    function setInputTokensBasedOnFT(amount_FT: bigint) {
        //-----------
        if (fund === undefined) return;
        //-----------
        console.log(`setInputTokensBasedOnFT - amount_FT: ${amount_FT}`);
        //-----------
        // iterate invest unit investUnitTokens
        // for each token
        //-----------
        const investUnitTokens = fund.investUnit!.investUnitWithADAPrices.iuValuesWithDetailsAndAmount;
        //-----------
        const inputTokens: Token_With_Metadata_And_Amount[] = investUnitTokens.map((investUnitToken) => {
            const requiredAmountDecimals = Number(investUnitToken.amount) / INVESTUNIT_MULTIPLIER; // invest unit is mulplied by 100
            // uso math ceil para asegurar que esa cantidad entera cubre la cantidad de FT que se pueden comprar
            const amount = BigInt(Math.ceil(Number(amount_FT) * requiredAmountDecimals));
            //-----------
            const tokenWithMetadata = tokensStore.getTokenPriceAndMetadata(investUnitToken.CS, investUnitToken.TN_Hex);
            //-----------
            return { ...investUnitToken, ...tokenWithMetadata, amount };
        });
        //-----------
        console.log(`setInputTokensBasedOnFT - inputTokens: ${toJson(inputTokens)}`);
        //-----------
        setInputTokens(inputTokens);
        //-----------
    }
    //--------------------------------------
    function calculate_Get_FT_from_InputTokens(minInvestUnits: bigint) {
        //-----------
        if (fund === undefined || isServerTimeLoaded === false || serverTime === undefined) return;
        //-----------
        console.log(`calculate_Get_FT_from_InputTokens - minInvestUnits: ${minInvestUnits}`);
        //--------------------------------------
        const now = serverTime;
        //--------------------------------------
        const deadline = fund.fdDeadline;
        const commissions_Table_Numerator_1e6 = fund.fdCommissions_Table_Numerator_1e6;
        //---------------------
        const { userFT, commissionsFT } = FundEntity.calculateDepositCommissions(commissions_Table_Numerator_1e6, deadline, BigInt(now), minInvestUnits);
        //---------------------
        if (userFT > 0n) {
            setCommission_FT(commissionsFT);
            setReal_FT(minInvestUnits);
            setInputFT(userFT);
        } else {
            setCommission_FT(0n);
            setReal_FT(0n);
            setInputFT(0n);
        }
        //---------------------
    }
    //--------------------------------------
    function calculate_Give_Tokens_from_FT(inputFT: bigint) {
        //-----------
        if (fund === undefined || isServerTimeLoaded === false || serverTime === undefined) return;
        //-----------
        console.log(`calculate_Give_Tokens_from_FT - inputFT: ${inputFT}`);
        //--------------------------------------
        const now = serverTime;
        //--------------------------------------
        const deadline = fund.fdDeadline;
        const commissions_Table_Numerator_1e6 = fund.fdCommissions_Table_Numerator_1e6;
        //---------------------
        const { deposit, commissionsFT } = FundEntity.calculateDepositCommissions_FromUserFT(commissions_Table_Numerator_1e6, deadline, BigInt(now), inputFT);
        //---------------------
        setCommission_FT(commissionsFT);
        setReal_FT(deposit);
        //---------------------
        setInputTokensBasedOnFT(deposit);
        //---------------------
    }
    //--------------------------------------
    function calculate_Give_FT_from_InputTokens(minInvestUnits: bigint) {
        //-----------
        if (fund === undefined || serverTime === undefined) return;
        //-----------
        console.log(`calculate_Give_FT_from_InputTokens - minInvestUnits: ${minInvestUnits}`);
        //--------------------------------------
        const now = serverTime;
        //--------------------------------------
        const deadline = fund.fdDeadline;
        const commissions_Table_Numerator_1e6 = fund.fdCommissions_Table_Numerator_1e6;
        //---------------------
        const { commissionsForUserFTToGetBack, withdraw } = FundEntity.calculateWithdrawCommissions_fromWithdrawPlusCommission(
            commissions_Table_Numerator_1e6,
            deadline,
            BigInt(now),
            minInvestUnits
        );
        //---------------------
        if (withdraw > 0n) {
            setCommission_FT(commissionsForUserFTToGetBack);
            setReal_FT(minInvestUnits);
            setInputFT(withdraw);
        } else {
            setCommission_FT(0n);
            setReal_FT(0n);
            setInputFT(0n);
        }
        //---------------------
    }
    //--------------------------------------
    function calculate_Get_Tokens_from_FT(inputFT: bigint) {
        //-----------
        if (fund === undefined || serverTime === undefined) return;
        //-----------
        console.log(`calculate_Get_Tokens_from_FT - inputFT: ${inputFT}`);
        //--------------------------------------
        const now = serverTime;
        //--------------------------------------
        const deadline = fund.fdDeadline;
        const commissions_Table_Numerator_1e6 = fund.fdCommissions_Table_Numerator_1e6;
        //---------------------
        const { commissionsForUserFTToGetBack, withdrawPlusCommissionsGetBack } = FundEntity.calculateWithdrawCommissions(
            commissions_Table_Numerator_1e6,
            deadline,
            BigInt(now),
            inputFT
        );
        //---------------------
        setCommission_FT(commissionsForUserFTToGetBack);
        setReal_FT(withdrawPlusCommissionsGetBack);
        //---------------------
        setInputTokensBasedOnFT(withdrawPlusCommissionsGetBack);
        //---------------------
    }
    //--------------------------------------
    const handleClickToggleDepositWithdraw = () => {
        if (isDeposit === true) {
            setIsDeposit(false);
            setInputFT(inputFT);
            handleChange_InputFT(inputFT, false);
        } else {
            setIsDeposit(true);
            setInputFT(inputFT);
            handleChange_InputFT(inputFT, true);
        }
    };
    //--------------------------------------
    function handleChange_InputFT(inputFT: bigint, isDeposit_?: boolean) {
        //-----------
        console.log(`handleChange_InputFT - inputFT: ${inputFT}`);
        //-----------
        isDeposit_ = isDeposit_ ?? isDeposit;
        setInputFT(inputFT);
        if (isDeposit_ === true) {
            calculate_Give_Tokens_from_FT(inputFT);
        } else {
            calculate_Get_Tokens_from_FT(inputFT);
        }
        //-----------
    }
    //--------------------------------------
    function handleChange_InputTokens(inputTokens: Token_With_Metadata_And_Amount[], isDeposit_?: boolean) {
        //-----------
        if (fund === undefined) return;
        //-----------
        console.log(`handleChange_InputTokens - inputTokens INIT: ${toJson(inputTokens)}`);
        //-----------
        isDeposit_ = isDeposit_ ?? isDeposit;
        //-----------
        // tengo que depurar la lista de tokens para evitar tener FT deciaml
        // para eso voy a ver cuantos FT compra con cada token, haciendo floor, y me quedo con el menor valor
        // luego multiplico todos los tokens por ese valor
        //-----------
        let minInvestUnitsDecimals: number | undefined = undefined;
        //-----------
        const investUnitTokens = fund.investUnit!.investUnitWithADAPrices.iuValuesWithDetailsAndAmount;
        //-----------
        inputTokens.forEach((token, index) => {
            //-----------
            const requiredAmountDecimals = Number(investUnitTokens[index].amount) / INVESTUNIT_MULTIPLIER; // invest unit is mulplied by 100
            const possibleUnitsDecimals = Number(token.amount) / requiredAmountDecimals;
            //-----------
            minInvestUnitsDecimals = minInvestUnitsDecimals === undefined || possibleUnitsDecimals < minInvestUnitsDecimals ? possibleUnitsDecimals : minInvestUnitsDecimals;
        });
        //-----------
        const minInvestUnits = BigInt(Math.floor(minInvestUnitsDecimals ?? 0));
        // no necesito decimales, solo quiero el menor valor entero de FT que se pueden conseguir con los tokens que tengo
        //-----------
        const inputTokensResult = inputTokens.map((token, index) => {
            //-----------
            const requiredAmountDecimals = Number(investUnitTokens[index].amount) / INVESTUNIT_MULTIPLIER; // invest unit is mulplied by 100
            // uso math ceil para asegurar que esa cantidad entera cubre la cantidad de FT que se pueden comprar
            const amount = BigInt(Math.ceil(Number(minInvestUnits) * requiredAmountDecimals));
            //-----------
            return { ...token, amount };
        });
        //-----------
        console.log(`handleChange_InputTokens - minInvestUnits: ${minInvestUnits}`);
        console.log(`handleChange_InputTokens - inputTokens RESULT: ${toJson(inputTokensResult)}`);
        //-----------
        setInputTokens(inputTokensResult);
        //-----------
        if (isDeposit_ === true) {
            calculate_Get_FT_from_InputTokens(minInvestUnits);
        } else {
            calculate_Give_FT_from_InputTokens(minInvestUnits);
        }
        //-----------
    }
    //--------------------------------------
    const handleBtnDepositTx = async () => {
        //--------------------------------------
        // console.log (`protocol: ${protocol} - fund: ${fund}`);
        const fetchParams = async () => {
            //--------------------------------------
            if (protocol === undefined || fund === undefined) {
                throw 'protocol === undefined || fund === undefined';
            }
            //--------------------------------------
            const { lucid, emulatorDB, walletTxParams } = await LucidToolsFrontEnd.prepareLucidFrontEndForTx(walletStore);
            //--------------------------------------
            const txParams: FundDepositTxParams = {
                protocol_id: protocol._DB_id,
                fund_id: fund._DB_id,
                pfdpAmount: real_FT,
            };
            return {
                lucid,
                emulatorDB,
                walletTxParams,
                txParams,
            };
        };
        //--------------------------------------
        const txApiCall = FundTxApiCalls.callGenericTxApi.bind(FundTxApiCalls);
        const handleBtnTx = FundBtnHandlers.handleBtnDoTransaction_V2_NoErrorControl.bind(FundBtnHandlers);
        //--------------------------------------
        await handleBtnDoTransaction_WithErrorControl(FundEntity, 'Deposit Tx', 'Depositing...', 'deposit', fetchParams, txApiCall, handleBtnTx);
        //--------------------------------------
    };
    const handleBtnWithdrawTx = async () => {
        //--------------------------------------
        const fetchParams = async () => {
            //--------------------------------------
            if (protocol === undefined || fund === undefined) {
                throw 'protocol === undefined || fund === undefined';
            }
            //--------------------------------------
            const { lucid, emulatorDB, walletTxParams } = await LucidToolsFrontEnd.prepareLucidFrontEndForTx(walletStore);
            //--------------------------------------
            const txParams: FundWithdrawTxParams = {
                protocol_id: protocol._DB_id,
                fund_id: fund._DB_id,
                pfwpAmount: inputFT,
            };
            return {
                lucid,
                emulatorDB,
                walletTxParams,
                txParams,
            };
        };
        //--------------------------------------
        const txApiCall = FundTxApiCalls.callGenericTxApi.bind(FundTxApiCalls);
        const handleBtnTx = FundBtnHandlers.handleBtnDoTransaction_V2_NoErrorControl.bind(FundBtnHandlers);
        //--------------------------------------
        await handleBtnDoTransaction_WithErrorControl(FundEntity, 'Withdraw Tx', 'Withdrawing...', 'withdraw', fetchParams, txApiCall, handleBtnTx);
        //--------------------------------------
    };
    const handleBtnDepositOrWithdrawTx = async () => {
        if (isDeposit === true) {
            await handleBtnDepositTx();
        } else {
            await handleBtnWithdrawTx();
        }
    };
    //--------------------------------------
    const handleBtnArrangeUTxO = async () => {
        try {
            // const confirmText = isDeposit
            //     ? `This transaction will consolidate all your available tokens for the deposit into a single UTxO and create additional UTxOs for fees and collateral. Do you wish to proceed?`
            //     : `This transaction will isolate the token to be redeemed into a single UTxO and create additional UTxOs for fees and collateral. Do you wish to proceed?`;

            const confirmText = isDeposit
                ? `We've detected that your wallet's UTxOs could be optimized before making a deposit. This is *not* required, but if a future deposit transaction fails, we recommend running this operation first. Would you like to proceed with a preparation transaction to consolidate and arrange your UTxOs?`
                : `We've detected that your wallet's UTxOs could be optimized before redeeming. This is *not* required, but if a future redemption transaction fails, we recommend running this operation first. Would you like to proceed with a preparation transaction to consolidate and arrange your UTxOs?`;

            if (confirm(confirmText)) {
                setIsProcessingArrangeUTxOTx(true);

                const { lucid, emulatorDB, walletTxParams } = await LucidToolsFrontEnd.prepareLucidFrontEndForTx(walletStore);
                const allUTxOs = walletStore.uTxOsAtWallet;

                if (!fund || !fund.investUnit) throw 'Missing fund or investUnit';

                const ADA_THRESHOLD = 5_000_000n;

                // ---------------------- DEPOSIT PATH ----------------------
                if (isDeposit) {
                    const tokenKeys = fund.investUnit.iudInvestUnit.iuValues.map(([policyId, tokenNameHex]) => `${policyId}${tokenNameHex}`);

                    const utxosWithFundTokens = allUTxOs.filter((utxo) => {
                        const keys = Object.keys(utxo.assets).filter((k) => k !== 'lovelace');
                        return keys.some((k) => tokenKeys.includes(k));
                    });

                    if (utxosWithFundTokens.length === 0) throw 'No UTxOs with fund tokens found.';

                    const totalValue = utxosWithFundTokens.reduce((acc, utxo) => {
                        for (const [key, amount] of Object.entries(utxo.assets)) {
                            acc[key] = (acc[key] ?? 0n) + amount;
                        }
                        return acc;
                    }, {} as Record<string, bigint>);

                    const value_TokensUTxO: Record<string, bigint> = {};
                    const value_AdaOnlyUTxO_1: Record<string, bigint> = { lovelace: ADA_THRESHOLD };
                    const value_AdaOnlyUTxO_2: Record<string, bigint> = { lovelace: ADA_THRESHOLD };

                    for (const tokenKey of tokenKeys) {
                        if (totalValue[tokenKey]) {
                            value_TokensUTxO[tokenKey] = totalValue[tokenKey];
                        }
                    }
                    value_TokensUTxO['lovelace'] = ADA_THRESHOLD;

                    let tx = lucid
                        .newTx()
                        .collectFrom(utxosWithFundTokens)
                        .pay.ToAddress(walletTxParams.address, value_TokensUTxO)
                        .pay.ToAddress(walletTxParams.address, value_AdaOnlyUTxO_1)
                        .pay.ToAddress(walletTxParams.address, value_AdaOnlyUTxO_2)
                        .addSigner(walletTxParams.address);

                    //--------------------------------------
                    const txComplete = await tx.complete();
                    //--------------------------------------
                    const txCborHex = txComplete.toCBOR({ canonical: true });
                    //--------------------------------------
                    const txHash = await LucidToolsFrontEnd.signAndSubmitTx(lucid, txCborHex, walletStore.info, emulatorDB, walletStore.swDoNotPromtForSigning);
                    //--------------------------------------
                    const confirmed = await LucidToolsFrontEnd.awaitTxSimple(lucid, txHash);
                    if (!confirmed) throw `Tx not confirmed`;

                    pushSucessNotification(`Arrange UTxOs`, txHash, true);
                }
                // ---------------------- WITHDRAW PATH ----------------------
                else {
                    const tokenKey = `${fund.getNET_id_CS()}${fund.fdFundFT_TN_Hex}`;

                    const utxosWithToken = allUTxOs.filter((utxo) => tokenKey in utxo.assets);
                    if (utxosWithToken.length === 0) throw 'No UTxO with the redeemable token found.';

                    const totalAmount = utxosWithToken.reduce((acc, utxo) => {
                        return acc + (utxo.assets[tokenKey] ?? 0n);
                    }, 0n);

                    const value_TokenOnlyUTxO: Record<string, bigint> = {
                        [tokenKey]: totalAmount,
                        lovelace: ADA_THRESHOLD,
                    };

                    const value_AdaOnlyUTxO_1: Record<string, bigint> = { lovelace: ADA_THRESHOLD };
                    const value_AdaOnlyUTxO_2: Record<string, bigint> = { lovelace: ADA_THRESHOLD };

                    let tx = lucid
                        .newTx()
                        .collectFrom(utxosWithToken)
                        .pay.ToAddress(walletTxParams.address, value_TokenOnlyUTxO)
                        .pay.ToAddress(walletTxParams.address, value_AdaOnlyUTxO_1)
                        .pay.ToAddress(walletTxParams.address, value_AdaOnlyUTxO_2)
                        .addSigner(walletTxParams.address);

                    //--------------------------------------
                    const txComplete = await tx.complete();
                    //--------------------------------------
                    const txCborHex = txComplete.toCBOR({ canonical: true });
                    //--------------------------------------
                    const txHash = await LucidToolsFrontEnd.signAndSubmitTx(lucid, txCborHex, walletStore.info, emulatorDB, walletStore.swDoNotPromtForSigning);
                    //--------------------------------------
                    const confirmed = await LucidToolsFrontEnd.awaitTxSimple(lucid, txHash);
                    if (!confirmed) throw `Tx not confirmed`;

                    pushSucessNotification(`Arrange UTxOs`, txHash, true);
                }

                setIsProcessingArrangeUTxOTx(false);
                await walletStore.loadWalletData();
            }

            setShowUserConfirmation(true)
            return true;

        } catch (error) {
            setIsProcessingArrangeUTxOTx(false);
            const error_explained = explainErrorTx(error);
            console.log(`handleBtnArrangeUTxO - Error: ${error_explained}`);
            pushWarningNotification(`Arrange UTxOs`, error_explained);
            return false;
        }
    };

    //--------------------------------------
    return (
        <>
            {/* {`protocol: ${protocol} - fund: ${fund}`} */}
            {(props.isLoadedDetails === true && fund !== undefined) || (props.isLoadingDetails === true && fund !== undefined && fund._DB_id === id) ? (
                <main className={styles.depositSection}>
                    <div className={styles.header}>
                        <div className={styles.fundSelector}>
                            <h2 className={styles.fundTitle}>{isDeposit ? `MINT ${hexToStr(fund.fdFundFT_TN_Hex)}` : `REDEEM ${hexToStr(fund.fdFundFT_TN_Hex)}`}</h2>
                            {props.isLoadingDetails === true && <LoaderButton />}
                        </div>
                        <div className={styles.toggleGroup}>
                            <TogleViewListOrDetailsController {...props} />
                            <ToggleProController />
                        </div>
                    </div>
                    {/* {(showUTxOError || isProcessingArrangeUTxOTx) && (
                        <>
                            <div className={styles.UTxOError}>
                                <p className={styles.title}>
                                    <>We detected issues with your UTxOs:</>
                                </p>
                                <ul className={styles.details}>
                                    <li>You need at least two UTxOs with only ADA (≥ 5 ADA each) for fees and collateral.</li>
                                    {isDeposit ? (
                                        <li>You must have one UTxO that contains all the fund&lsquo;s tokens together, with no extra tokens, and at least 5 ADA.</li>
                                    ) : (
                                        <li>You must have one UTxO that contains only the fund token to be redeemed, with no extra tokens, and at least 5 ADA.</li>
                                    )}
                                </ul>
                                <div className={styles.btn}>
                                    <Button mode="action" className={styles.btn} onClick={handleBtnArrangeUTxO} disabled={isProcessingArrangeUTxOTx}>
                                        Arrange UTxOs
                                        {isProcessingArrangeUTxOTx && <LoaderButton />}
                                    </Button>
                                </div>
                            </div>
                        </>
                    )} */}
                    <DepositForm
                        fund={fund}
                        protocol={protocol}
                        isDeposit={isDeposit}
                        isTokensStoreReady={isTokensStoreReady}
                        isAddingTokens={isAddingTokens}
                        isValidTx={isValidTx}
                        isValidInputTokens={isValidInputTokens}
                        isValidInputFT={isValidInputFT}
                        setIsValidInputFT={setIsValidInputFT}
                        inputTokens={inputTokens}
                        inputFT={inputFT}
                        commission_FT={commission_FT}
                        real_FT={real_FT}
                        handleChange_InputTokens={handleChange_InputTokens}
                        handleChange_InputFT={handleChange_InputFT}
                        handleClickToggleDepositWithdraw={handleClickToggleDepositWithdraw}
                        available_FT_in_Wallet_Based_On_Tokens={available_FT_in_Wallet_Based_On_Tokens}
                        available_FT_in_Wallet={available_FT_in_Wallet}
                        amount_Tokens_Available_In_Wallet={amount_Tokens_Available_In_Wallet}
                        amount_Tokens_Available_In_Wallet_Based_On_FT={amount_Tokens_Available_In_Wallet_Based_On_FT}
                        isProcessingTx={isProcessingTx}
                        setShowProcessingTx={setShowProcessingTx}
                        setShowUserConfirmation={setShowUserConfirmation}
                        isMaxAmountLoaded={isMaxAmountLoaded}
                        showUTxOError={showUTxOError}
                        isProcessingArrangeUTxOTx={isProcessingArrangeUTxOTx}
                        handleBtnArrangeUTxO={handleBtnArrangeUTxO}
                    />
                </main>
            ) : (
                <div className={styles.depositSectionLoading}>
                    <div className={styles.controller}>
                        <div className={styles.headerController}>
                            <h2 className={styles.titleController}>{isDeposit ? `MINT...` : `REDEEM...`}</h2>
                            {/* <div className={styles.toggleController}>
                                <p className={`${styles.text} ${styles.active}`}>Deposit</p>
                                <div className={styles.toggle}>
                                    <span className={`${styles.point} ${styles.active}`}></span>
                                </div>
                                <p className={styles.text}>Withdraw</p>
                            </div> */}
                        </div>
                        <div className={styles.bodyController}>
                            <div className={styles.rowLoader}></div>
                            <div className={styles.commissionController}>
                                <div className={styles.rowLoader}></div>
                                <div className={styles.rowLoader}></div>
                                <div className={styles.rowLoader}></div>
                            </div>
                            <div className={styles.rowLoader}></div>
                            <div className={styles.confirmationSection}>LOADING...</div>
                        </div>
                    </div>
                </div>
            )}
            {showUserConfirmation && walletStore.isConnected === true && fund !== undefined && (
                <>
                    <TxUserConfirmationModal
                        title={isDeposit ? `MINT ${hexToStr(fund.fdFundFT_TN_Hex)}` : `REDEEM ${hexToStr(fund.fdFundFT_TN_Hex)}`}
                        protocol={protocol}
                        fund={fund}
                        isValidTx={isValidTx}
                        btnTxInvalidName={'Invalid Tx please try again'}
                        tokensGive={tokensGiveWithMetadata}
                        tokensGet={tokensGetWithMetadata}
                        showExtraInfo={walletStore.swProInterface === true}
                        extraInfo={
                            walletStore.swProInterface === true &&
                            fund !== undefined && <Commission fund={fund} isDeposit={isDeposit} commission_FT={commission_FT} real_FT={real_FT} classNameStyle="darker" />
                        }
                        onConfirm={async () => handleBtnDepositOrWithdrawTx()}
                        onCancel={async () => setShowUserConfirmation(false)}
                    />
                </>
            )}

            <TxProcessingModal
                showProcessingTx={showProcessingTx}
                setShowProcessingTx={setShowProcessingTx}
                isProcessingTx={isProcessingTx}
                processingTxMessage={processingTxMessage}
                processingTxHash={processingTxHash}
                isFaildedTx={isFaildedTx}
                isConfirmedTx={isConfirmedTx}
                onTryAgainTx={onTryAgainTx}
                onFinishTx={onFinishTx}
                showNewTransactionButton={false}
                showViewTransactionsButton={false}
                showTryAgainTransactionButton={true}
                othersButtonsWhenConfirmed={
                    <>
                        <Button
                            mode="outline"
                            width={'100%'}
                            onClick={async () => {
                                setShowProcessingTx(false);
                                await router.push({
                                    pathname: ROUTES.PORTFOLIO,
                                });
                            }}
                        >
                            View Portfolio
                        </Button>
                    </>
                }
            />
        </>
    );
}
